export default __webpack_public_path__ + "static/media/8D.ca4420e9.svg";